// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.highlight[data-v-5a2e08ad] { background-color: #ffeb3b !important;\n}\n.responsive-table[data-v-5a2e08ad] { max-width: 100%; overflow-x: auto;\n}\n.disabled-table[data-v-5a2e08ad] { opacity: 0.6; pointer-events: none;\n}\n", ""]);
// Exports
module.exports = exports;
